import { authorizePostRequest } from "api";
import { IUploadResponse } from "models/upload";

export const uploadFleetModelApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/fleet-model`, form);
};

export const uploadFleetApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/fleet`, form);
};

export const uploadLicenseApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/license`, form);
};

export const uploadDriverApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/driver`, form);
};
export const uploadDriverLicenseApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/driving-license`, form);
};
export const uploadInsuranceSubscriptionApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(
    `uploads/insurance-subscription`,
    form
  );
};
export const uploadEmploymentAgreementApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(
    `uploads/employment-agreement`,
    form
  );
};
export const uploadMaheberSupportApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/maheber-support`, form);
};
export const uploadDriverIdApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/driver-id`, form);
};
export const uploadOwnerIdApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(
    `uploads/vehicle-owner-id`,
    form
  );
};
export const uploadBoloApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/bolo`, form);
};
export const uploadBusinessLicenseApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(
    `uploads/business-license`,
    form
  );
};

export const uploadNewsApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/news`, form);
};

export const uploadPassengerApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/passenger`, form);
};

export const uploadOthersApi = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return authorizePostRequest<IUploadResponse>(`uploads/others`, form);
};
